import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Icon, IconWrapper } from '@honda-canada/design-system-react';
import themeStyles from '../ConfigureBapStyles';
const IconContainer = themeStyles.apply(IconWrapper, 'IconContainer');
const AddToBuildIcon = themeStyles.apply(Icon, 'AddToBuildIcon');
const AccessoryCardIcon = ({ isSelected, onClick }) => (_jsx(IconContainer, { as: "button", position: "absolute", cursor: "pointer", border: "none", "data-testid": isSelected ? 'cy-accessory-selected' : 'cy-accessory-unselected', "aria-label": isSelected ? 'accessory selected' : 'accessory unselected', onClick: () => {
        if (onClick) {
            onClick();
        }
    }, children: _jsx(AddToBuildIcon, { iconColor: "blue", name: isSelected ? 'selected' : 'unselected' }) }));
export default AccessoryCardIcon;
